export const CartAdded = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_109_13377)">
        <path
          d="M9.57175 6.4375H3.12081L2.70913 2.9375H6V2.0625H2.60588L2.5875 1.9085C2.5498 1.58939 2.39634 1.29519 2.15621 1.08167C1.91608 0.868149 1.60596 0.750137 1.28463 0.75H0.75V1.625H1.28463C1.39178 1.62501 1.49521 1.66436 1.57529 1.73556C1.65537 1.80677 1.70653 1.90489 1.71906 2.01131L2.4125 7.90356C2.4501 8.22275 2.60352 8.51705 2.84366 8.73067C3.0838 8.94428 3.39398 9.06235 3.71538 9.0625H9.5V8.1875H3.71538C3.60815 8.18747 3.50467 8.14807 3.42458 8.07677C3.34449 8.00548 3.29338 7.90725 3.28094 7.80075L3.22363 7.3125H10.3033L10.697 5.125H9.80844L9.57175 6.4375Z"
          fill="#706A85"
        />
        <path
          d="M3.8125 11.25C4.29575 11.25 4.6875 10.8582 4.6875 10.375C4.6875 9.89175 4.29575 9.5 3.8125 9.5C3.32925 9.5 2.9375 9.89175 2.9375 10.375C2.9375 10.8582 3.32925 11.25 3.8125 11.25Z"
          fill="#706A85"
        />
        <path
          d="M8.1875 11.25C8.67075 11.25 9.0625 10.8582 9.0625 10.375C9.0625 9.89175 8.67075 9.5 8.1875 9.5C7.70425 9.5 7.3125 9.89175 7.3125 10.375C7.3125 10.8582 7.70425 11.25 8.1875 11.25Z"
          fill="#706A85"
        />
        <path
          d="M8.22182 4.48745H8.23626C8.34479 4.4878 8.4523 4.4666 8.55256 4.42507C8.65283 4.38354 8.74384 4.3225 8.82032 4.24551L11.122 1.94382L10.5034 1.3252L8.2367 3.59407L7.25495 2.57032L6.62451 3.1767L7.63339 4.2267C7.70878 4.30764 7.79978 4.37248 7.90092 4.4173C8.00205 4.46211 8.11122 4.48597 8.22182 4.48745Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_109_13377">
          <rect
            width="10.5"
            height="10.5"
            fill="white"
            transform="translate(0.75 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
